// extracted by mini-css-extract-plugin
export default {"theme-toggler":"ThemeToggle_theme-toggler__NUXJL","toggle":"ThemeToggle_toggle__d28MN","indicator":"ThemeToggle_indicator__u4gVb"};